import styled from '@emotion/styled';
import {mixinFlexboxRow, mixinOverflow, mixinSVGIcon} from 'webapp-lib/styling';

import {StyledListItem} from '#/List/Item/styles';
import {Header, StyledListSection} from '#/List/Section/styles';
import {StyledList} from '#/List/styles';

export const ExclamationMark = styled.div<{show?: boolean}>`
  width: 32px;
  text-align: center;
  user-select: none;
  margin-top: var(--gutter-tiny);
  color: var(--color-alerts-error);
`;

export const RowContainer = styled.div<{isUnread?: boolean}>`
  display: -webkit-box;
  -webkit-box-orient: vertical;
  flex-grow: 1;
  line-height: 24px;
  width: 0;
  ${({isUnread}): string =>
    isUnread
      ? 'font-weight: var(--item-unread-font-weight);'
      : 'font-weight: var(--item-read-font-weight);'}
`;

export const DateWrapper = styled.span<{isUnread?: boolean}>`
  margin: var(--gutter-tiny) var(--gutter-little);
  ${({isUnread}): string =>
    isUnread
      ? 'font-weight: var(--item-unread-font-weight);'
      : 'font-weight: var(--item-read-font-weight);'}
`;

export const StyledNotificationsList = styled.div<{activated?: boolean}>`
  ${mixinOverflow}
  flex-grow: 1;

  ${StyledListSection} {
    border-top-width: 0;
    border-bottom: var(--regular-border-width) solid var(--color-box-border);
    padding-bottom: var(--gutter-small);
    padding-top: 0;

    :not(:first-of-type) {
      margin-top: var(--gutter);
    }

    ${Header} {
      margin-left: 0;
      font-weight: var(--font-weight-title);
      color: var(--color-core-primary);
    }
  }

  > ${StyledList}>${StyledListItem} {
    ${mixinFlexboxRow}
    align-items: start;
    border-bottom: var(--regular-border-width) solid var(--color-box-border);
    padding: var(--gutter-little) var(--gutter-little) var(--gutter-little)
      var(--gutter);
    color: var(--color-core-black);
    cursor: pointer;
    min-height: 42px;
    height: auto;

    :first-of-type {
      border-top: var(--regular-border-width) solid var(--color-box-border);
    }

    > svg {
      ${mixinSVGIcon}
      margin-top: var(--gutter-tiny);
      fill: var(--color-core-primary);
    }
  }
`;
